import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ProductCard from "./ProductCard";
import { useDispatch, useSelector } from "react-redux";
import { loadProducts } from "../redux/productRedux";
import { selectProducts } from "../redux/productRedux";

const Container = styled.main`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`;

export default function ProductList({ sort, category }) {
  const dispatch = useDispatch();
  const products = useSelector(selectProducts);

  // get products
  useEffect(() => {
    dispatch(loadProducts());
  }, [dispatch]);

  // apply sort filter
  const [sorted, setSorted] = useState(products);
  useEffect(() => {
    if (sort === "asc") {
      setSorted(prev => [...prev].sort((a, b) => a.price - b.price));
    } else {
      setSorted(prev => [...prev].sort((a, b) => b.price - a.price));
    }
  }, [sort, products]);

  return (
    <Container>
      {sorted
        // filter items by category before displaying them all
        .filter(item => {
          // shortcircuts filter
          if (category === "") {
            return products;
          } else {
            return item.category.includes(category);
          }
        })
        .map(item => (
          <ProductCard {...item} key={item._id} />
        ))}
    </Container>
  );
}
